module.exports = __webpack_public_path__ + "static/media/product5.85c85f78.png";